module.exports = __webpack_public_path__ + "static/img/14000699.0dbc1168.png";